<template>
  <!-- プレオプトインダイアログ(カスタマイズなし)のサンプル -->
  <div class="coins-optin-dialog">
    <div class="coins-optin-dialog-icon">
      <img
        style="vertical-align: top !important"
        :src="dialogValues.icon"
      />
    </div>
    <div class="coins-optin-dialog-text-box">
      <div class="coins-close-button" @click="$emit('close')"><span></span></div>
      <span>{{ dialogValues.message }}</span>
      <div class="coins-optin-dialog-button-box">
        <button class="coins-optin-dialog-button" @click="$emit('close')">
          {{ dialogValues.button }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogValues: {
      icon: String,
      message: String,
      button: String,
    },
  },
  emits: ["close"],
};
</script>

<style scoped>
@keyframes CoinsShowAnimation {
    0% {
        opacity: 0;
        transform: translateY(100px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes CoinsHideAnimation {
    0% {
        opacity: 1;
        transform: translateY(0);
    }
    100% {
        opacity: 0;
        transform: translateY(100px);
    }
}

.coins-close-button {
    display: inline-block;
    width: 24px;
    height: 24px;
    position: absolute;
    cursor: pointer;
    border-radius: 50%;
    right: 4px;
    top: 4px;
}
.coins-close-button span::before,
.coins-close-button span::after {
    display: block;
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 84%;
    height: 10%;
    margin: -8% 0 0 -42%;
    background: gray;
}
.coins-close-button span::before {
    transform: rotate(-45deg);
}
.coins-close-button span::after {
    transform: rotate(45deg);
}

.coins-optin-dialog {
    z-index: 9999;
    position: fixed;
    background-color: white;
    width: 500px;
    bottom: 10px;
    right: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    animation-name: CoinsShowAnimation;
    animation-duration: 0.5s;
}

.coins-optin-dialog:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

@media screen and (max-width: 600px) {
    .coins-optin-dialog {
        width: 100%;
        bottom: 0;
        left: 0;
    }
}

.coins-optin-dialog-icon {
    display: inline-block;
    vertical-align: top;
}

.coins-optin-dialog-text-box {
    display: inline-block;
    word-wrap: break-word;
    vertical-align: top;
    max-width: 70%;
}

.coins-optin-dialog-icon > img {
    width: 84px;
    height: 84px;
}

.coins-optin-dialog-text-box > span {
    display: block;
    margin-top: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: medium;
    color: gray;
    width: 380px;
}

.coins-optin-dialog-button-box {
    text-align: right;
    display: inline-block;
    min-width: 110%;
    box-sizing: border-box;
}

@media screen and (max-width: 600px) {
    .coins-optin-dialog-text-box > span {
        width: auto;
        font-size: small;
        margin-bottom: 0px;
        margin-top: 4px;
    }

    .coins-optin-dialog-button-box {
        min-width: 70vw;
    }
}

.coins-optin-dialog-button-box > button {
    display: inline-block;
    position: relative;
    bottom: 0px;
    border: none;
    cursor: pointer;
    outline: none;
    appearance: none;
}

.coins-optin-dialog-button {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    color: gray;
    padding: 4px;
    min-width: 80px;
    min-height: 28px;
    font-size: small;
    margin-left: 10px;
}

.coins-optin-dialog-button:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.coins-optin-dialog-text-link {
    display: inline-block;
    border-radius: 4px;
    color: #0073cf;
    padding: 4px;
    min-width: 80px;
    min-height: 28px;
    font-size: small;
    margin-top: 10px;
    margin-left: 10px;
}
</style>
